import UploadImage from "../UploadImage";
import { useState } from "react";
import Titel from "../Titel";
import InputField from "../InputField";
import validation from "../../../Validations/Blog";
import useAxios from '../../../hooks/useAxios';
import RichTextEditor from "../../TextEditor";
import Tags from "../Paint/Tags";
import Attributs from "./Attributes/Attributes";
import AttributesList from "./Attributes/AttributesList";

const NewBlog = () => {
    const { AxiosPrivate } = useAxios()
    const [data, setData] = useState({ images: [], title: '', body: '', product_ids: [], attributes: [] })
    const [loading, setLoading] = useState(false)
    const [touch, setTouch] = useState({})
    const errors = validation(data)

    const handleChange = (e) => {
        const { name, value } = e.target
        setData(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (Object.keys(errors).length) {
            setTouch({ title: true, images: true, body: true })
        } else {
            await AxiosPrivate.post('blog/store', data, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: () => {
                    setLoading(true)
                },
            })
                .then(res => {
                    alert(res.data.message);
                    window.location.reload();
                })
                .catch(err => alert(err.response?.data.message || 'مشکلی پیش آمده'))
                .finally(() => setLoading(false))
        }
    }
    const handleEditorChange = (e, name) => setData(prev => ({ ...prev, [name]: e }))
    return (
        <>
            <div className="max-w-xl w-full mx-auto my-4">
                <Titel title="افزودن بلاگ جدید" className="md:text-xl" />
                <form className="flex flex-col items-center" onSubmit={handleSubmit}>
                    <div className="flex flex-wrap items-center justify-between mt-6 gap-x-1">
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <UploadImage setData={setData} errors={errors} touch={touch} label='عکس اصلی' name='images' images={data.images} />
                        </div>
                        <InputField label={'عنوان'} id={7} max_width={'100%'} name={'title'} type={'text'} {...{ data, touch, errors, handleChange }} />
                        <InputField label={'نام نویسنده'} id={8} max_width={'100%'} name={'author_name'} type={'text'} {...{ data, touch, errors, handleChange }} />
                        <InputField label={'توضیحات نویسنده'} id={9} max_width={'100%'} name={'author_body'} type={'text'} {...{ data, touch, errors, handleChange }} />
                        <div className="flex flex-col gap-2 items-start relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <label>فهرست</label>
                            <div className="w-full relative">
                                <RichTextEditor value={data.table_of_contents} onChange={(e) => handleEditorChange(e, 'table_of_contents')} />
                            </div>
                            {touch.table_of_contents && errors.table_of_contents && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors.table_of_contents}</p>}
                        </div>
                        <div className="flex flex-col gap-2 items-start relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <label>توضیحات کوتاه</label>
                            <div className="w-full relative">
                                <RichTextEditor value={data.body_before_table} onChange={(e) => handleEditorChange(e, 'body_before_table')} />
                            </div>
                            {touch.body_before_table && errors.body_before_table && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors.body_before_table}</p>}
                        </div>
                        <div className="flex flex-col gap-2 items-start relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <label>توضیحات</label>
                            <div className="w-full relative">
                                <RichTextEditor value={data.body} onChange={(e) => handleEditorChange(e, 'body')} />
                            </div>
                            {touch.body && errors.body && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors.body}</p>}
                        </div>
                        <div className="flex flex-col gap-2 items-start relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <label>توضیحات آخر</label>
                            <div className="w-full relative">
                                <RichTextEditor value={data.body_after_product} onChange={(e) => handleEditorChange(e, 'body_after_product')} />
                            </div>
                            {touch.body_after_product && errors.body_after_product && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors.body_after_product}</p>}
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <Tags data={data} id={19} setData={setData} errors={errors} touch={touch} name='product_ids' label='آیدی محصولات' />
                        </div>
                        <div className='flex flex-col mb-8 w-full'>
                            <Attributs setProduct={setData} />
                            <div className='relative'>
                                <AttributesList data={data.attributes} setProduct={setData} />
                                {touch.attributes && errors.attributes && <span className="absolute right-2 bottom-0 text-xs text-red-600">{errors.attributes}</span>}
                            </div>
                        </div>
                        <InputField label={'تایتل'} id={333} max_width={'100%'} name={'seo_title'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'اسلاگ'} id={334} max_width={'100%'} name={'slug'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'دیسکریپشن'} id={335} max_width={'100%'} name={'meta_description'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    </div>
                    <button disabled={loading} className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                     focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ">{loading ?
                            <div role="status">
                                <svg stroke="currentColor" aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin fill-gray-50" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"></path></svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                            : 'ثبت'}</button>
                </form >
            </div >
        </>
    );
};

export default NewBlog;